<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div
        v-bind="$attrs"
        class="d-flex"
        :class="{'waffle-box-toggle-btn-group': true, 'waffle-box-toggle-error': (question.error || displayError) && hasBeenInteractedWith}"
        role="group"
        aria-label="Basic toggle button group"
        @focusin="onContainerFocus"
        @focusout="onContainerBlur"
        >
      <template v-for="(option, index) in question.options" :key="index">
        <input
            type="radio"
            class="btn-check"
            :name="`${question.name}`"
            :id="`${question.name}-radio-${option.value}`"
            :disabled="disabled"
            autocomplete="off"
            :value="option.value"
            :checked="option.value === value"
            tabindex="-1"
            @click.stop="$emit('user-interaction');setChoiceValue(option.value)"
        />

        <label
            ref="optionLabels"
            role="button"
            :class="['waffle-box-toggle-btn',
            { 'waffle-box-toggle-selected': option.value === value },
            { 'border-setup-1': !hasBeenInteracted },
            { 'border-outline': focusedIndex === index },
            ' waffle-box-toggle-label btn-outline-dark']"
            :for="`${question.name}-radio-${option.value}`" :id="`${question.name}-label-${option.value}`" v-html="option.text"
            :tabindex="0"
            @keydown="handleKeyDown($event, option.value, index)"
            @focus="setFocusedIndex(index)"
            ></label>
      </template>
    </div>
    <slot name="helptext" :isError="displayError" :isConfirm="!disableConfirm && (question.value && question.prefilled) && !displayError"
          :confirmCb="() => {$emit('user-interaction');$emit('confirm')}"></slot>
  </template>
  <ReadOnly
      v-else
      :question="question"
      :value="this.value ? `${this.value}`:'-'"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>
<script>

import ReadOnly from "@/components/themeable-components/ReadOnly.vue";

export default {
  name: 'BoxToggle',
  components: {ReadOnly},
  emits: ['update:modelValue', 'field-error','confirm','user-interaction'],
  props: ['question', 'modelValue', 'hideSubText', 'skipEagerValidation','disableConfirm','forcePromptPlaceholder', 'hasBeenInteractedWith','disabled'],
  data() {
    return {
      value: "",
      displayError: '',
      focusedIndex: -1,
      hasBeenInteracted: false,
    }
  },
  mounted() {
    this.value = this.question.value
    this.displayError = this.question.error
    if (!this.skipEagerValidation) {
      this.validate(this.question.error)
    }
    this.$emit('update:modelValue', this.value);
    document.addEventListener("click", this.handleDocumentClick);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  watch: {
    question: {
      handler(newQuestion) {
        if (newQuestion.value !== undefined) {
          if(newQuestion.value !== this.value){
            this.$emit('update:modelValue', newQuestion.value);
          }
          this.value = newQuestion.value
        }

        if (newQuestion.error) {
          this.displayError = newQuestion.error
        } else {
          this.displayError = ''
        }
      },
      deep: true,
    }
  },
  methods: {
    validate(backendError){
      if(backendError){
        this.$emit('field-error', true)
        this.displayError = backendError
        return true
      }

      const required = this.question.required
      if (required && !this.value && (this.hasBeenInteractedWith && !this.skipEagerValidation || true)) {
        this.$emit('field-error', true)
        this.displayError = 'Required. '
        return true
      }
      this.$emit('field-error', false)
      this.displayError = ''
      return false
    },
    setChoiceValue(v) {
      if(this.value !== v){
        this.value = v
        this.$nextTick(() => {
          if(!this.validate()){
            return this.$emit('update:modelValue', this.value);
          }
        })
      }
    },
    handleKeyDown(event, optionValue) {
      if (event.key === 'Enter') {
        this.hasBeenInteracted = true;
        this.setChoiceValue(optionValue);
        this.$emit('user-interaction');
        event.preventDefault();
      }
    },
    setFocusedIndex(index) {
      this.focusedIndex = index;
    },
    onContainerFocus() {
      if (this.focusedIndex === -1) {
        this.focusedIndex = 0;
        const labels = Array.isArray(this.$refs.optionLabels)
          ? this.$refs.optionLabels
          : [this.$refs.optionLabels];
        if (labels && labels[0]) {
          labels[0].focus();
        }
      }
    },
    onContainerBlur() {
      setTimeout(() => {
        if (!this.$el.contains(document.activeElement)) {
          this.focusedIndex = -1;
        }
      }, 0);
    },
    handleDocumentClick(event) {
      if (!this.$el.contains(event.target)) {
        this.focusedIndex = -1;
      }
    },
  }
}
</script>
